export const HUB_LOAD_REQUEST = 'HUB_LOAD_REQUEST';
export const HUB_LOAD_SUCCESS = 'HUB_LOAD_SUCCESS';
export const HUB_LOAD_FAILURE = 'HUB_LOAD_FAILURE';
